import React from 'react'
import PropTypes from 'prop-types'

import { sendExceptionToSentry } from '../../js/sentry'

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.any
  }

  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error(error)
    sendExceptionToSentry(error, info)
  }

  render() {
    if (this.state.hasError) {
      return <h4>Something went wrong, the error is reported, please refresh the page to try again.</h4>
    }

    return this.props.children
  }
}

export default ErrorBoundary
